// Shared brand assets, content and motion variants for Onarf Marketing

export const LOGO_DIAMOND =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_920a81fd-a97e-45af-97a7-aab9b0f002d0/artifacts/8b3bqjng_onarf.png";
export const LOGO_FULL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_920a81fd-a97e-45af-97a7-aab9b0f002d0/artifacts/kyheagfn_ONARF_MARKETING_MAJICA_LOGO-removebg-preview.png";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  case1: "https://images.pexels.com/photos/5827294/pexels-photo-5827294.jpeg?auto=compress&cs=tinysrgb&w=1200",
  team: "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  process: "https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV = [
  { label: "Početna", href: "#pocetna" },
  { label: "Usluge", href: "#usluge" },
  { label: "Rezultati", href: "#rezultati" },
  { label: "O nama", href: "#o-nama" },
  { label: "Kontakt", href: "#kontakt" },
];

// Framer Motion variants
export const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const lineReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { duration: 0.9, delay: 0.15 + i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};
